/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  ChangeRequest,
  ChangeRequestContentChange,
  ChangeRequestContentUpdate,
  EntityId,
  List,
  Revision,
  RevisionFile,
  RevisionPage,
  RevisionPageDocument,
  RevisionPageGroup,
  RevisionPageMetaLinks,
  RevisionReusableContent,
  RevisionSemanticChanges,
} from "./data-contracts";

/**
 * @description Returns the current revision snapshot of the change request, including the full page tree structure and metadata. Use this to inspect the overall state of the change request's content, such as the list of pages and their hierarchy, without fetching each page individually. For page content (body text), use the individual page endpoints.
 * @tags change-request-content
 * @name GetRevisionOfChangeRequestById
 * @summary Get the latest content revision of a change request
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content
 * @secure
 */

// @ts-ignore
export const getRevisionOfChangeRequestById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Revision;
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/content",
  method: "get",
  streaming: false,
  tags: ["change-request-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Applies an ordered array of content changes (up to 50) to the change request atomically, creating a single new revision. Changes are applied sequentially; if any single change is invalid the entire batch is rejected and no revision is created. Use this to create, update, rename, move, or delete pages within a change request before merging to live. This is the primary way to programmatically author content in a change request. **Renaming a page** — `update_page` can change a page's `title` and/or its `slug` (the path segment used to build its URL within its current parent). Both fields are independent: to rename only the title without changing the URL, set `title` and omit `slug`; to change the URL without changing the title, set `slug` and omit `title`. **Moving a page** — `update_page` can also change a page's parent and/or its position among siblings with `into`/`at`. Set `into` to the new parent's page ID, or `null` to move the page to the root of the tree; omit `into` to leave the parent unchanged. Set `at` to place the page at a specific zero-based index among its new siblings; omit it to leave the position unchanged (when the parent isn't changing) or append at the end (when it is). A page cannot be moved under itself or one of its own descendants. `insert_page`'s `into`/`at` remain the way to place a **new** page at creation time. **Tags**: create flat tag definitions with `insert_tags` and a `tags` array of 1-50 entries, edit their label or appearance with `update_tag`, and remove definitions with `delete_tag`. Slugs are immutable and generated from the label when omitted on insertion. Operations apply in order, so later updates or deletions can target newly inserted tags. Set `icon` or `emoji` to `null` to clear that field; omission preserves it. A non-null icon takes precedence over a non-null emoji. Deleting a tag leaves references in content unresolved. For example: `{"changes":[{"operation":"insert_tags","tags":[{"label":"Beta"}]}, {"operation":"update_tag","tag":"beta","color":"blue"}]}`. To put an image or attachment in a page, upload it with an `insert_files` change. Give the file a `ref` and a page inserted in the same batch can reference it as `![Alt](./<ref>)` or `[File](./<ref>)`, which resolves to the file's ID at apply time regardless of operation order. Uploaded files are also listed as `insertedFiles` when `compat=false`, and a file already in the change request can be referenced directly as `/files/<fileId>`. Inline `data:` URIs in markdown are not ingested and large image blocks are dropped, so upload the bytes with `insert_files` instead. **Reusable content** (snippets shared by several pages, Git Sync's `.gitbook/includes/`) is created with `insert_reusable_contents`, changed with `update_reusable_content` and removed with `delete_reusable_content`. A page includes one in markdown as `{% include "/reusable-content/<reusableContentId>" %}`; give a new one a `ref` and a page in the same batch can include it as `{% include "./<ref>" %}`, regardless of operation order. Created reusable contents are listed as `insertedReusableContents` when `compat=false`. An update keeps the ID, so every page including it shows the change. Deleting one leaves the includes in pages unresolved, as in the editor: remove them from those pages too. Reusable content cannot include other reusable content, so an include in its document is dropped. Unlike a link, an include that matches no reusable content of the change request (or of the batch) rejects the batch, since dropping it would remove it from the page silently. **Variables** (space variables, Git Sync's `.gitbook/vars.yaml`) are created with `insert_variables`, changed with `update_variable` and removed with `delete_variable`. A variable is identified by its name, which content references as an expression: `<code class="expression">space.vars.<name></code>` in markdown. Inserting a name the change request already uses, or updating or deleting one it does not, rejects the batch. Deleting a variable keeps the expressions referencing it, as in the editor: remove them from those pages too. A page's own variables (`page.vars.<name>`) are set with `insert_page`/`update_page`'s `variables`, or the `vars` frontmatter of a markdown document, which replace all of that page's variables. To change one of them without resending the rest, give `insert_variables`, `update_variable` or `delete_variable` a `page`; the same rules apply to that page's variables. **Publishing an OpenAPI spec** — an OpenAPI spec belongs to the organization (see `createOpenAPISpec`) and appears in a space only through a page that renders it. Insert that page with an `insert_computed_page` change: `{ "operation": "insert_computed_page", "title": "API reference", "computed": { "type": "builtin:openapi", "props": { "models": true }, "dependencies": { "spec": { "ref": { "kind": "openapi", "spec": "<spec slug>" } } } } }`. GitBook replaces that page, at its position, with the API reference: one page per tag (or per operation with `"grouping": "by-operation"` in `props`), plus a models page when `models` is true, regenerated whenever the spec changes. Use `into` to nest the reference under an existing page. Do not recreate a spec with `insert_page`: `openapi-operation` blocks in a document only render the operations they name. When page content is provided as markdown, links to other pages are resolved against the change request's current page tree. You can link a page by: - Page ID — `/pages/<pageId>` (also `/pages/<pageId>#anchor`). - Page slug path — `/pages/<slug>` for a top-level page, or `/pages/<parent-slug>/<slug>` for a nested page (e.g. `/pages/guides/getting-started`). - Markdown file path — the path the page would have in Git: `/pages/<slug>.md` for a page, or `/pages/<slug>/README.md` for a page that has child pages. The space's root page is `/pages/README.md`. - Relative markdown link — resolved against the page being edited, e.g. `./sibling.md`, `../other.md`, or `../README.md` (the parent page). Folder-style links without an extension (e.g. `./section`) resolve to that folder's page. External URLs (`https://…`) are kept as-is. A link that does not match any page in the change request is left as plain text rather than causing the request to fail. GitBook normalizes submitted content, so the stored page may differ from what was sent. To help callers reconcile local state with the stored result, the response can list each created and modified page with its resolved ID and a `urls.location` to fetch the page's persisted content. For change requests with frequent concurrent edits, consider `expectedRevision` to protect against overwriting changes made since your read. If the branch has changed since the supplied revision, the batch is rejected with HTTP 409 and none of the submitted changes are applied. **Response shape (`compat`)** — this endpoint is changing what it returns: - `compat=true` (current default) returns the updated change request, matching the endpoint's original behavior. - `compat=false` returns the updated change request **and** the list of affected pages (see the response schema). The default is `true` for now to preserve backwards compatibility, but **will switch to `false` in a future release**, at which point the affected-page list is always included. You should pass `compat=false` if you want the new behavior today and avoid unexpected errors when the default flips in the future.
 * @tags change-request-content
 * @name UpdateChangeRequestContent
 * @summary Apply a batch of content changes to a change request
 * @request POST:/spaces/{spaceId}/change-requests/{changeRequestId}/content
 * @secure
 */

// @ts-ignore
export const updateChangeRequestContent: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
  };
  RequestQuery: {
    /**
     * When `true`, the updated change request is returned. When `false`, the updated change request and the list of affected pages are returned.
     * @default true
     */
    compat?: boolean;
  };
  RequestBody: {
    /**
     * The saved branch revision on which these changes are based, available in getChangeRequestById's revision field. If the branch has changed, including pending realtime edits, the batch is rejected with 409 and none of the submitted changes are applied. This field is optional and most changes can omit it.
     * @minLength 1
     */
    expectedRevision?: string;
    /**
     * @maxItems 50
     * @minItems 1
     */
    changes: ChangeRequestContentChange[];
  };
  RequestHeaders: {};
  ResponseBody: ChangeRequest | ChangeRequestContentUpdate;
  ResponseStatusCode: 200 | 404 | 409;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/content",
  method: "post",
  streaming: false,
  tags: ["change-request-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the full flat list of all pages in the change request's current draft revision, including page groups. Does not include page body content — use the individual page endpoint to fetch content. Use this to get an overview of the draft's page structure before reading or modifying specific pages.
 * @tags change-request-content
 * @name ListPagesInChangeRequest
 * @summary List all pages in a change request as a flat list
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/pages
 * @secure
 */

// @ts-ignore
export const listPagesInChangeRequest: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    pages: RevisionPage[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/content/pages",
  method: "get",
  streaming: false,
  tags: ["change-request-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns a paginated list of files (images and other attachments) stored in the change request's current revision. Use this to inspect uploaded assets within a draft before merging. For files in the live published space, use the space content files endpoint.
 * @tags change-request-content
 * @name ListFilesInChangeRequestById
 * @summary List all files (images/attachments) in a change request
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/files
 * @secure
 */

// @ts-ignore
export const listFilesInChangeRequestById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: RevisionFile[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/content/files",
  method: "get",
  streaming: false,
  tags: ["change-request-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Retrieves metadata for a single file (image or attachment) stored in the change request's current revision. Use this to get the download URL or details of a specific asset referenced by a page in the change request.
 * @tags change-request-content
 * @name GetFileInChangeRequestById
 * @summary Get a specific file in a change request by its ID
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/files/{fileId}
 * @secure
 */

// @ts-ignore
export const getFileInChangeRequestById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
    /** The unique id of the file */
    fileId: EntityId;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionFile;
  ResponseStatusCode: 200;
} = {
  route:
    "/spaces/{spaceId}/change-requests/{changeRequestId}/content/files/{fileId}",
  method: "get",
  streaming: false,
  tags: ["change-request-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Retrieves a specific page from a change request's draft content, including its title, metadata, and body document. Use the documentFormat parameter to control the format of the returned document (e.g., markdown). This reflects the draft state of the page, not the live published version — use the space content page endpoint for live content.
 * @tags change-request-content
 * @name GetPageInChangeRequestById
 * @summary Get a page in a change request by its ID
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/page/{pageId}
 * @secure
 */

// @ts-ignore
export const getPageInChangeRequestById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
    /** The unique id of the page */
    pageId: EntityId;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
    /**
     * Controls how content references are formatted in markdown output. Ignored unless `format=markdown`.
     *
     * - `relative`: Format page references as relative links from the current page. Other references might not be handled.
     * - `stable`: Format content references as stable idempotent refs containing their identifiers.
     * @default "relative"
     */
    "format.markdown.refs"?: "relative" | "stable";
    /**
     * Controls whether the document should be evaluated.
     * - When set to `true`, the entire document will be evaluated.
     * - When set to `deterministic-only`, only expressions that depend
     *   exclusively on deterministic inputs will be evaluated.
     * @default false
     */
    evaluated?: boolean | "deterministic-only";
    /**
     * Controls whether references to other content are resolved and expanded.
     * - When set to `false`, references are preserved, including reusable content includes in Markdown.
     * - When set to `true`, all supported content references are expanded.
     * - When set to `reusable-contents`, only reusable content references are expanded.
     * When omitted, Markdown responses expand all supported content references, while document responses preserve them.
     */
    dereferenced?: boolean | "reusable-contents";
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionPage;
  ResponseStatusCode: 200;
} = {
  route:
    "/spaces/{spaceId}/change-requests/{changeRequestId}/content/page/{pageId}",
  method: "get",
  streaming: false,
  tags: ["change-request-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the structural navigation links for a specific page within a change request, such as its parent page, previous sibling, and next sibling in the page tree. Use this to understand a page's position within the content hierarchy of the draft.
 * @tags change-request-content
 * @name ListChangeRequestPageMetaLinks
 * @summary Get navigation meta-links (prev/next/parent) for a change request page
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/page/{pageId}/meta-links
 * @secure
 */

// @ts-ignore
export const listChangeRequestPageMetaLinks: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
    /** The unique id of the page */
    pageId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionPageMetaLinks;
  ResponseStatusCode: 200;
} = {
  route:
    "/spaces/{spaceId}/change-requests/{changeRequestId}/content/page/{pageId}/meta-links",
  method: "get",
  streaming: false,
  tags: ["change-request-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Retrieves a specific reusable content block (a shared snippet that can be embedded across multiple pages) from the change request's draft revision. Use this to inspect the current draft state of a shared content block before merging.
 * @tags change-request-content
 * @name GetReusableContentInChangeRequestById
 * @summary Get a reusable content block in a change request by its ID
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/reusable-contents/{reusableContentId}
 * @secure
 */

// @ts-ignore
export const getReusableContentInChangeRequestById: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
    /** The unique id of the reusable content */
    reusableContentId: EntityId;
  };
  RequestQuery: {
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionReusableContent;
  ResponseStatusCode: 200;
} = {
  route:
    "/spaces/{spaceId}/change-requests/{changeRequestId}/content/reusable-contents/{reusableContentId}",
  method: "get",
  streaming: false,
  tags: ["change-request-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns the semantic diff between the change request's current content and the base revision it branched from. Each item describes a logical change such as a page added, removed, or modified. Use this to summarise what a change request changes before merging or reviewing. The default limit is 10 — increase it if the change request is large.
 * @tags change-request-content
 * @name GetChangeRequestChanges
 * @summary List semantic content changes in a change request vs its base
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/changes
 * @secure
 */

// @ts-ignore
export const getChangeRequestChanges: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
  };
  RequestQuery: {
    /**
     * Limit the number of changes returned
     * @default 10
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionSemanticChanges;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/spaces/{spaceId}/change-requests/{changeRequestId}/changes",
  method: "get",
  streaming: false,
  tags: ["change-request-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Retrieves a specific page from a change request's draft content using its URL path (e.g., "getting-started/installation") rather than its ID. Use this when you know the path of a page but not its ID. Returns either a document page or a page group, depending on the path. Supports the same format and evaluation options as the ID-based endpoint.
 * @tags change-request-content
 * @name GetPageInChangeRequestByPath
 * @summary Get a page in a change request by its URL path
 * @request GET:/spaces/{spaceId}/change-requests/{changeRequestId}/content/path/{pagePath}
 * @secure
 */

// @ts-ignore
export const getPageInChangeRequestByPath: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the space */
    spaceId: EntityId;
    /** The unique ID of the change request or its number identifier in the space */
    changeRequestId: EntityId;
    /** The path of the page in the revision. */
    pagePath: string;
  };
  RequestQuery: {
    /** Output format for the content. */
    format?: "document" | "markdown";
    /**
     * Controls how content references are formatted in markdown output. Ignored unless `format=markdown`.
     *
     * - `relative`: Format page references as relative links from the current page. Other references might not be handled.
     * - `stable`: Format content references as stable idempotent refs containing their identifiers.
     * @default "relative"
     */
    "format.markdown.refs"?: "relative" | "stable";
    /**
     * Controls whether the document should be evaluated.
     * - When set to `true`, the entire document will be evaluated.
     * - When set to `deterministic-only`, only expressions that depend
     *   exclusively on deterministic inputs will be evaluated.
     * @default false
     */
    evaluated?: boolean | "deterministic-only";
    /**
     * Controls whether references to other content are resolved and expanded.
     * - When set to `false`, references are preserved, including reusable content includes in Markdown.
     * - When set to `true`, all supported content references are expanded.
     * - When set to `reusable-contents`, only reusable content references are expanded.
     * When omitted, Markdown responses expand all supported content references, while document responses preserve them.
     */
    dereferenced?: boolean | "reusable-contents";
    /**
     * If `false` is passed, "git" mutable metadata will not returned. Passing `false` can optimize performances of the lookup.
     * @default true
     */
    metadata?: boolean;
    /**
     * If `true` is passed, mutable Git metadata may be served from a cache.
     * @default false
     */
    cachedMetadata?: boolean;
    /**
     * If `false` is passed, content will not be computed
     * @default true
     */
    computed?: boolean;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: RevisionPageDocument | RevisionPageGroup;
  ResponseStatusCode: 200;
} = {
  route:
    "/spaces/{spaceId}/change-requests/{changeRequestId}/content/path/{pagePath}",
  method: "get",
  streaming: false,
  tags: ["change-request-content"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
